export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export function parseBulk(text) {
  return text.split(/\r?\n/).map((l) => l.trim()).filter(Boolean).map((line) => {
    const parts = line.split(/[,;\t]+/).map((p) => p.trim()).filter(Boolean);
    const email = (parts.find((p) => EMAIL_RE.test(p)) || "").toLowerCase();
    const name = parts.filter((p) => p !== email && !EMAIL_RE.test(p)).join(" ").trim();
    return { name, email, valid: !!email };
  });
}

export const resolveBandJs = (bands, years) => {
  if (!bands || !bands.length) return null;
  const y = years || 0;
  const eligible = bands.filter((b) => (b.min_years || 0) <= y);
  if (eligible.length) return eligible.reduce((a, b) => ((b.min_years || 0) > (a.min_years || 0) ? b : a));
  return bands.reduce((a, b) => ((b.min_years || 0) < (a.min_years || 0) ? b : a));
};
export const openSlots = (e) => (e.availability || []).filter((s) => !s.booked && !s.busy).length ||
  (e.open_slots != null ? e.open_slots : 0);
export const countryOf = (loc) => {
  if (!loc) return "Remote";
  const parts = String(loc).split(",");
  return parts[parts.length - 1].trim();
};
export const EXP_LEVELS = [0, 3, 5, 10, 15];
export const SORTS = {
  rating: (a, b) => (b.rating_avg || 0) - (a.rating_avg || 0),
  experience: (a, b) => (b.years_experience || 0) - (a.years_experience || 0),
  availability: (a, b) => openSlots(b) - openSlots(a),
  name: (a, b) => a.name.localeCompare(b.name),
};
